import { HttpService } from 'src/api/common/HttpService';
import { UrlService } from 'src/api/common/UrlService';
import { ApiStatus } from 'src/constants/ApiStatus';
import { CteApiUrl } from 'src/constants/BaseUrls';

type ResponseType = {
  sourceSessionId: number | string;
};

export const EmployeeService = () => {
  const { HttpGet, HttpPost, HttpDelete } = HttpService();

  const GetAll = async (body: any) => {
    const suffix =
      typeof body === 'string' ? body : UrlService.BuildQuery(body);
    const url = `${CteApiUrl}/api/v1/employee${suffix}`;
    const response = await HttpGet(url);
    return response;
  };

  const GetById = async (body: ResponseType) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${CteApiUrl}/api/v1/employee/detail${suffix}`;
    const response = await HttpGet(url);
    return response;
  };

  return {
    GetAll,
    GetById,
  };
};
